import React, { useRef, useEffect } from "react";

const POINTS = 32;
const LINE_DIST = 110;
const SPEED = 0.08;
const COLOR = "#7ecfff";
const LINE_COLOR = "rgba(126,207,255,0.09)";

function random(min, max) {
  return Math.random() * (max - min) + min;
}

const SidebarWeb = () => {
  const canvasRef = useRef(null);
  const points = useRef([]);
  const animationRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = canvas.width = canvas.offsetWidth;
    let height = canvas.height = canvas.offsetHeight;

    points.current = Array.from({ length: POINTS }, () => ({
      x: random(0, width),
      y: random(0, height),
      vx: random(-SPEED, SPEED),
      vy: random(-SPEED, SPEED)
    }));

    function animate() {
      ctx.clearRect(0, 0, width, height);
      // Линии
      for (let i = 0; i < POINTS; i++) {
        for (let j = i + 1; j < POINTS; j++) {
          const a = points.current[i];
          const b = points.current[j];
          const dx = a.x - b.x;
          const dy = a.y - b.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < LINE_DIST) {
            ctx.strokeStyle = LINE_COLOR;
            ctx.lineWidth = 1 - dist / LINE_DIST;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
        }
      }
      // Точки
      for (let i = 0; i < POINTS; i++) {
        const p = points.current[i];
        ctx.beginPath();
        ctx.arc(p.x, p.y, 1.1, 0, 2 * Math.PI);
        ctx.fillStyle = "rgba(126,207,255,0.13)";
        ctx.fill();
      }
      // Движение
      for (let i = 0; i < POINTS; i++) {
        const p = points.current[i];
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > width) p.vx *= -1;
        if (p.y < 0 || p.y > height) p.vy *= -1;
      }
      animationRef.current = requestAnimationFrame(animate);
    }
    animate();
    // Resize
    const handleResize = () => {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
    };
    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(animationRef.current);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        background: 'transparent',
        transition: 'opacity 0.5s'
      }}
    />
  );
};

export default SidebarWeb; 